import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {formatTextTestIds} from "@next/utils"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface ColourwayBodyProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    title: string
    tooltipTitle: string
    enableSingleLineTitle: boolean
}

export const ColourwayTitle = memo(({templating, title, tooltipTitle, enableSingleLineTitle}: ColourwayBodyProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <ComponentName
            variant="body1"
            title={tooltipTitle}
            data-testid={formatTextTestIds(`product_summary_title`)}
            data-label={title}
            data-desc={title}
            data-usespan="False"
            $singleLineTitle={enableSingleLineTitle}
        >
            {title}
        </ComponentName>
    )
})
ColourwayTitle.displayName = "ColourwayTitle"

export default connect(ColourwayTitle)
